import { render, staticRenderFns } from "./compToOne.vue?vue&type=template&id=4c180d18&scoped=true"
import script from "./compToOne.vue?vue&type=script&lang=js"
export * from "./compToOne.vue?vue&type=script&lang=js"
import style0 from "./compToOne.vue?vue&type=style&index=0&id=4c180d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c180d18",
  null
  
)

export default component.exports